import styled from 'styled-components';

import MuiContainer from '@mui/material/Container';

export const Container = styled(MuiContainer)`
  padding: ${({ theme }) => theme.spacing(3)};
`;
